import React from 'react';
import './ErrorBag.scss';
import classNames from 'classnames';

function ErrorBag({ errors = [], ...props }) {
  return errors.length ? (
    <div className='error-bag' {...props}>
      {errors.map((error, index) => {
        return (
          <div key={index} className={classNames('invalid-feedback', 'error-item', error?.className ?? null)} >
            {error?.message ?? error}
          </div>
        );
      })}
    </div>
  ) : null;
}

export default ErrorBag;
